module.exports = __webpack_public_path__ + "static/media/choose_pack.7775866b.svg";